import { z } from 'zod'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { UpdateMenuOverviewRequestSchema } from '~/services/api/generated'
import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'

const schema = UpdateMenuOverviewRequestSchema.strict()

const normalize = fieldNormalizer({
  lists: [
    {
      key: 'categories',
      spec: {
        int: ['category_id', 'order'],
        lists: [{ key: 'items', spec: { int: ['item_id', 'order'], float: ['price'] } }]
      }
    }
  ]
})

const hasAtMostTwoDecimals = (value: number): boolean =>
  Math.abs(value * 100 - Math.round(value * 100)) < 1e-9

export const MenuUpdateOverview = (_context: NoContext): z.ZodType<z.output<typeof schema>> =>
  z.preprocess(normalize, schema).superRefine((value, issues) => {
    value.categories.forEach((category, categoryIndex) => {
      category.items?.forEach((item, itemIndex) => {
        if (!hasAtMostTwoDecimals(item.price)) {
          issues.addIssue({
            code: 'custom',
            message: 'The price field must have 0-2 decimal places',
            path: ['categories', categoryIndex, 'items', itemIndex, 'price']
          })
        }
      })
    })
  })
